import { Injectable } from '@angular/core';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { EmailPlaceholder } from '../common/common-actions.service';

@Injectable({
  providedIn: 'root',
})
export class FindingsActionsService {
  private readonly _findingsEmailPlaceholders: EmailPlaceholder[];

  constructor(private readonly _labelProvider: LabelsProviderPipe) {
    this._findingsEmailPlaceholders = [
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.findingName.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.findingName.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.findingSeverity.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.findingSeverity.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.findingTimestamp.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.findingTimestamp.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.aiService.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.aiService.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.findingRuleSummary.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.findingRuleSummary.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.findingRuleResponseRecommendation.label'),
        description: this._labelProvider.transform(
          'emailTemplatePlaceholders.findingRuleResponseRecommendation.description'
        ),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.findingRuleHowToInvestigate.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.findingRuleHowToInvestigate.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.agentName.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.agentName.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.linkToZenity.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.linkToZenity.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.actorEmail.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.actorEmail.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.findingCoreEvidence.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.findingCoreEvidence.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.secretType.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.secretType.description'),
      },
      {
        label: this._labelProvider.transform('emailTemplatePlaceholders.informationClassification.label'),
        description: this._labelProvider.transform('emailTemplatePlaceholders.informationClassification.description'),
      },
    ];
  }

  public getFindingsEmailPlaceholders(): EmailPlaceholder[] {
    return this._findingsEmailPlaceholders;
  }
}
